import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const currentYear = new Date().getFullYear();
  return <footer className="bg-slate-950 py-8 md:py-12 px-4 border-t border-slate-900" data-id="element-1">
      <div className="max-w-3xl mx-auto text-center space-y-4 md:space-y-6" data-id="element-2">
        <div className="flex flex-wrap justify-center gap-6 text-sm font-medium" data-id="element-3">
          <button onClick={() => setIsPrivacyOpen(true)} className="text-amber-400 hover:text-amber-300 hover:underline transition-colors" data-id="element-4">
            Política de Privacidad
          </button>
          <button onClick={() => setIsTermsOpen(true)} className="text-amber-400 hover:text-amber-300 hover:underline transition-colors" data-id="element-5">
            Términos de Servicio
          </button>
        </div>

        <div className="space-y-2 text-slate-600 text-sm" data-id="element-6">
          <p data-id="element-7">© {currentYear} 3AM Otra Vez. Todos los derechos reservados.</p>
          <p className="text-xs max-w-lg mx-auto" data-id="element-8">
            Este producto es informativo y no sustituye consejo médico
            profesional. Si tienes problemas de salud graves, consulta a tu
            médico.
          </p>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      <Modal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} title="Política de Privacidad" data-id="element-9">
        <div className="space-y-4 text-sm leading-relaxed" data-id="element-10">
          <p data-id="element-11">Última actualización: {currentYear}</p>

          <h3 className="text-lg font-semibold text-amber-100 mt-6" data-id="element-12">
            1. Recopilación de Información
          </h3>
          <p data-id="element-13">
            Recopilamos información que usted nos proporciona directamente
            cuando realiza una compra, se suscribe a nuestro boletín o se
            comunica con nosotros. Esto puede incluir su nombre, dirección de
            correo electrónico y detalles de pago (procesados de forma segura
            por terceros).
          </p>

          <h3 className="text-lg font-semibold text-amber-100 mt-6" data-id="element-14">
            2. Uso de la Información
          </h3>
          <p data-id="element-15">
            Utilizamos su información para procesar sus pedidos, enviarle el
            contenido digital adquirido, comunicarnos con usted sobre nuestros
            productos y mejorar nuestros servicios. No vendemos sus datos
            personales a terceros.
          </p>

          <h3 className="text-lg font-semibold text-amber-100 mt-6" data-id="element-16">
            3. Cookies y Tecnologías Similares
          </h3>
          <p data-id="element-17">
            Utilizamos cookies para mejorar su experiencia en nuestro sitio web,
            analizar el tráfico y personalizar el contenido. Puede configurar su
            navegador para rechazar todas las cookies o para que le avise cuando
            se envíe una cookie.
          </p>

          <h3 className="text-lg font-semibold text-amber-100 mt-6" data-id="element-18">
            4. Seguridad de Datos
          </h3>
          <p data-id="element-19">
            Implementamos medidas de seguridad razonables para proteger su
            información personal contra pérdida, robo y uso no autorizado,
            divulgación o modificación.
          </p>

          <h3 className="text-lg font-semibold text-amber-100 mt-6" data-id="element-20">
            5. Sus Derechos
          </h3>
          <p data-id="element-21">
            Usted tiene derecho a acceder, corregir o eliminar su información
            personal. Si desea ejercer estos derechos, contáctenos a través de
            los canales proporcionados en la confirmación de su compra.
          </p>
        </div>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Términos de Servicio" data-id="element-22">
        <div className="space-y-4 text-sm leading-relaxed" data-id="element-23">
          <p data-id="element-24">Última actualización: {currentYear}</p>

          <h3 className="text-lg font-semibold text-amber-100 mt-6" data-id="element-25">
            1. Aceptación de los Términos
          </h3>
          <p data-id="element-26">
            Al acceder y utilizar este sitio web y comprar nuestros productos
            digitales, usted acepta estar sujeto a estos Términos de Servicio y
            a todas las leyes y regulaciones aplicables.
          </p>

          <h3 className="text-lg font-semibold text-amber-100 mt-6" data-id="element-27">
            2. Propiedad Intelectual
          </h3>
          <p data-id="element-28">
            Todo el contenido incluido en este sitio y en los productos
            digitales (textos, gráficos, logos, imágenes, clips de audio,
            descargas digitales) es propiedad de 3AM Otra Vez y está protegido
            por las leyes de derechos de autor. La compra le otorga una licencia
            personal, no exclusiva e intransferible para uso personal. No está
            permitida la redistribución, reventa o difusión pública.
          </p>

          <h3 className="text-lg font-semibold text-amber-100 mt-6" data-id="element-29">
            3. Descargo de Responsabilidad Médica
          </h3>
          <p data-id="element-30">
            El contenido proporcionado en "3AM Otra Vez" es solo para fines
            informativos y educativos. No pretende ser un sustituto del consejo
            médico profesional, diagnóstico o tratamiento. Siempre busque el
            consejo de su médico u otro proveedor de salud calificado con
            cualquier pregunta que pueda tener sobre una condición médica.
          </p>

          <h3 className="text-lg font-semibold text-amber-100 mt-6" data-id="element-31">
            4. Política de Reembolso
          </h3>
          <p data-id="element-32">
            Debido a la naturaleza digital de nuestros productos, ofrecemos una
            garantía de satisfacción limitada. Si no está satisfecho con su
            compra, contáctenos dentro de los 7 días posteriores a la compra
            para evaluar su caso.
          </p>

          <h3 className="text-lg font-semibold text-amber-100 mt-6" data-id="element-33">
            5. Limitación de Responsabilidad
          </h3>
          <p data-id="element-34">
            En ningún caso 3AM Otra Vez será responsable de daños directos,
            indirectos, incidentales o consecuentes que surjan del uso o la
            imposibilidad de uso de nuestros productos o servicios.
          </p>
        </div>
      </Modal>
    </footer>;
}